import { SET_ERROR, CLEAR_ERROR } from 'app/redux/constants';

export const initialState = null;

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR:
      return action.payload;
    case CLEAR_ERROR:
      return initialState;
    default:
      return state;
  }
};
